import { createGlobalStyle } from 'styled-components';

export const UploadGlobalStyles = createGlobalStyle`
  .preview-image {
    width: 100%;
  }
`;
